import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { loadableIzSearchesAtom, isHydrated } from "../../jotai/atoms";
import { SearchStatus } from "../../models/Interfaces";

export const MobileFooterTab = {
  SEARCH: "SEARCH",
  RECORDS: "RECORDS",
} as const;
export type MobileFooterTab = typeof MobileFooterTab[keyof typeof MobileFooterTab];

export default function MobileFooter({
  onTabChange,
}: {
  onTabChange?: (tab: MobileFooterTab) => void;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const isSearchActive = React.useMemo(
    () => location.pathname.includes("/home/search"),
    [location.pathname]
  );
  const isRecordsActive = React.useMemo(
    () => location.pathname.includes("/home/records"),
    [location.pathname]
  );
  const [allSearches] = useAtom(loadableIzSearchesAtom);
  const hasVerificationNeeded = React.useMemo(() => {
    if (allSearches.state !== "hasData" || !isHydrated(allSearches.data)) {
      return false;
    }

    return allSearches.data.some(
      (search) =>
        search.status.trim() === SearchStatus.partialMatchAltContacts && !search.dateVerified
    );
  }, [allSearches]);

  const onSearchClick = () => {
    onTabChange?.(MobileFooterTab.SEARCH);
    navigate("/home/search");
  };

  const onRecordsClick = () => {
    onTabChange?.(MobileFooterTab.RECORDS);
    navigate("/home/records");
  };

  return (
    <div
      data-testid="mobile-footer"
      className="dock bg-base-100 text-primary font-bold border-t-2 border-primary md:hidden"
    >
      <button className={` ${isSearchActive ? "dock-active" : ""} `} onClick={onSearchClick}>
        <div className="flex gap-2 justify-center items-center">
          <img className={"w-8"} src="/assets/images/Icon_Search.png" alt={"Search"} />
          <span>Search</span>
        </div>
      </button>

      <button className={` ${isRecordsActive ? "dock-active" : ""}`} onClick={onRecordsClick}>
        <div className="flex gap-2 justify-center items-center">
          <img
            className={"w-8"}
            src="/assets/images/Icon_Immunizations.png"
            alt={"Immunizations"}
          />
          <span>Records</span>
        </div>
      </button>
    </div>
  );
}
